import gql from 'graphql-tag'

export const CREATE_NOTIFICATION = gql`
  mutation create_notification($input: InputNotification) {
    create_notification(input: $input) {
      id
      active
      channels
      log_filter {
        type
        lang
        sources {
          model_id
          model_name
        }
      }
    }
  }
`
